import { Moment } from 'moment';
// Types
import { TicketEventDetailsFields } from 'api/ticketing/types/TicketEventDetailsFields';
import { RescheduleTicketEventInput } from 'api/graphql-global-types';
// Helpers
import { fromVenueInstant, toVenueInstant } from 'pages/Events/helpers';

type EventDetails = TicketEventDetailsFields;

export type RescheduleFormValues = {
  startsAt: Moment;
  endsAt: Moment;
  doorsOpenAt: Moment;
  admissionClosesAt: Moment;
  salesOpenAt?: Moment | null;
  salesCloseAt: Moment;
};

export const getRescheduleFormValues = (
  event: EventDetails
): RescheduleFormValues => {
  const toPicker = (value: string) => fromVenueInstant(value, event.timezone);

  return {
    startsAt: toPicker(event.startsAt),
    endsAt: toPicker(event.endsAt),
    doorsOpenAt: toPicker(event.doorsOpenAt),
    admissionClosesAt: toPicker(event.admissionClosesAt),
    salesOpenAt: event.salesOpenAt ? toPicker(event.salesOpenAt) : null,
    salesCloseAt: toPicker(event.salesCloseAt),
  };
};

export const buildRescheduleEventInput = (
  event: EventDetails,
  values: RescheduleFormValues
): RescheduleTicketEventInput => {
  const toInstant = (value: Moment) => toVenueInstant(value, event.timezone);

  return {
    ticketEventId: event.id,
    expectedVersion: event.version,
    startsAt: toInstant(values.startsAt),
    endsAt: toInstant(values.endsAt),
    doorsOpenAt: toInstant(values.doorsOpenAt),
    admissionClosesAt: toInstant(values.admissionClosesAt),
    salesCloseAt: toInstant(values.salesCloseAt),
    salesOpenAt: values.salesOpenAt ? toInstant(values.salesOpenAt) : null,
  };
};
